export interface HelpContractDocument {
  key: string;
  base64Document: string;
}

const PDF_BASE64_PREFIX = "data:application/pdf;base64,";

export const removePdfBase64Prefix = (base64Document: string): string => {
  if (base64Document.startsWith(PDF_BASE64_PREFIX)) {
    return base64Document.slice(PDF_BASE64_PREFIX.length);
  }

  return base64Document;
};

export const sanitizeHelpContractDocuments = (
  documents: Record<string, string | null> | null | undefined
): HelpContractDocument[] => {
  if (!documents) {
    return [];
  }

  return Object.entries(documents).reduce<HelpContractDocument[]>(
    (validDocuments, [documentKey, documentValue]) => {
      const hasValidKey = documentKey.trim() !== "" && documentKey !== "null";
      const hasValidValue =
        typeof documentValue === "string" && documentValue.trim() !== "";

      if (!hasValidKey || !hasValidValue) {
        return validDocuments;
      }

      validDocuments.push({
        key: documentKey,
        base64Document: removePdfBase64Prefix(documentValue),
      });

      return validDocuments;
    },
    []
  );
};
